"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveSepaBankAccountResultToJSON = exports.SaveSepaBankAccountResultFromJSONTyped = exports.SaveSepaBankAccountResultFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function SaveSepaBankAccountResultFromJSON(json) {
    return SaveSepaBankAccountResultFromJSONTyped(json, false);
}
exports.SaveSepaBankAccountResultFromJSON = SaveSepaBankAccountResultFromJSON;
function SaveSepaBankAccountResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'iban': !(0, runtime_1.exists)(json, 'iban') ? undefined : json['iban'],
        'bic': !(0, runtime_1.exists)(json, 'bic') ? undefined : json['bic'],
        'holder': !(0, runtime_1.exists)(json, 'holder') ? undefined : json['holder'],
        'mandateID': !(0, runtime_1.exists)(json, 'mandateID') ? undefined : json['mandateID'],
        'ibanWithStars': !(0, runtime_1.exists)(json, 'ibanWithStars') ? undefined : json['ibanWithStars'],
        'firstName': !(0, runtime_1.exists)(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !(0, runtime_1.exists)(json, 'lastName') ? undefined : json['lastName'],
        'customerNo': !(0, runtime_1.exists)(json, 'customerNo') ? undefined : json['customerNo'],
        'street': !(0, runtime_1.exists)(json, 'street') ? undefined : json['street'],
        'houseNumber': !(0, runtime_1.exists)(json, 'houseNumber') ? undefined : json['houseNumber'],
        'zipCode': !(0, runtime_1.exists)(json, 'zipCode') ? undefined : json['zipCode'],
        'city': !(0, runtime_1.exists)(json, 'city') ? undefined : json['city'],
        'uniqueCreditIdentifier': !(0, runtime_1.exists)(json, 'uniqueCreditIdentifier') ? undefined : json['uniqueCreditIdentifier'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
    };
}
exports.SaveSepaBankAccountResultFromJSONTyped = SaveSepaBankAccountResultFromJSONTyped;
function SaveSepaBankAccountResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'iban': value.iban,
        'bic': value.bic,
        'holder': value.holder,
        'mandateID': value.mandateID,
        'ibanWithStars': value.ibanWithStars,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'customerNo': value.customerNo,
        'street': value.street,
        'houseNumber': value.houseNumber,
        'zipCode': value.zipCode,
        'city': value.city,
        'uniqueCreditIdentifier': value.uniqueCreditIdentifier,
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
    };
}
exports.SaveSepaBankAccountResultToJSON = SaveSepaBankAccountResultToJSON;
//# sourceMappingURL=SaveSepaBankAccountResult.js.map